// extracted by mini-css-extract-plugin
export default {"table":"styles_table__59kiz","roundTrip":"styles_roundTrip__43rMN"};